import moment from "moment";
import { IDartsTournament } from "../../../Tournaments/TournamentsCRUD.types";

export const createTitleForDatePicker = (selectedTour: IDartsTournament | null) => {
    return selectedTour
        ?
        `Fixture date: (Select from 
            ${moment(selectedTour.dateStart).format("YYYY-MM-DD")} 
            to 
            ${moment(selectedTour.dateEnd).format("YYYY-MM-DD")})`
        : "Fixture date:"
}
